<template>
  <ModalUi @closeModal="toggleModals">
    <div class="modal-wrap">
      <div class="modal-block">
        <div class="modal-title">
          <h3>Создать черновик доставки</h3>
        </div>
        <button class="close" @click="toggleModals" type="button">
          <img src="/images/redesignedForm/close-button.svg" alt="close" />
        </button>
        <hr class="line" />
        <div class="modal-content">
          <div class="create-draft">
            <input
              type="text"
              @blur="touchField('alias')"
              v-model="alias"
              placeholder="Название черновика"
              ref="aliasField"
            />
          </div>
          <ValidationView :error-messages="getErrorMessages('alias')" />
          <div class="back-wrap">
            <button
              type="button"
              class="back"
              :class="getErrorClass('alias', 'red')"
              :disabled="getValidationError('alias')"
              @click="trySaveDraft"
            >
              Сохранить черновик
            </button>
          </div>
        </div>
      </div>
    </div>
  </ModalUi>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { required, helpers } from '@vuelidate/validators'
import { GENERAL_STORE } from '@apps/order-form/src/store'
import ModalUi from '@features/UI/ModalUi.vue'
import validationMixin from '@mixins/validationMixin'

export default {
  name: 'CreateDraftModal',
  components: { ModalUi },
  mixins: [validationMixin],
  data: () => ({
    alias: '',
  }),
  validations() {
    return {
      alias: {
        required: helpers.withMessage('Укажите название черновика', required),
        isAliasUnique: helpers.withMessage(
          'Черновик или шаблон с таким названием уже есть.',
          aliasName => !this.templates.find(template => template.alias === aliasName)
        ),
      },
    }
  },
  computed: {
    ...mapState(GENERAL_STORE, ['user', 'order']),
    ...mapGetters(GENERAL_STORE, ['templates']),
  },
  methods: {
    ...mapMutations(GENERAL_STORE, ['toggleModals']),
    ...mapActions(GENERAL_STORE, ['saveDraft']),

    async trySaveDraft() {
      const data = {
        user_id: this.user.id,
        alias: this.alias,
        is_suggestion: 0,
      }

      try {
        const { message } = await this.saveDraft(data)

        this.$toast.success(message || 'Черновик успешно сохранен.', { position: 'top' })
      } catch (e) {
        this.$toast.error(e.message, { position: 'top' })
      }

      this.toggleModals()
    },
  },
  mounted() {
    const list = this.order.dots
      .map(dot => [
        dot.address ? dot.address + (dot.building ? ` ${dot.building}` : '') : '',
        dot.contact,
        dot.phone,
        dot.items.map(item => item.name),
      ])
      .flat()
      .filter(Boolean)
      .find(val => val !== false)

    if (list) this.alias = list
  },
}
</script>

<style lang="scss" scoped>
.red {
  background-color: #de3e26 !important;
}

.invalid-text {
  margin-bottom: 10px;
}

.back-wrap {
  justify-content: space-around !important;

  @media (max-width: 575px) {
    flex-direction: column;

    button {
      margin-bottom: 10px;
    }
  }
}

.create-draft {
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 20px;

  input {
    width: 100%;
    height: 30px;
    padding: 0 10px;

    color: #5d5d5d;

    border: 1px solid #ced4da;
    border-radius: 3px;

    @media (max-width: 575px) {
      width: 100%;
    }
  }

  @media (max-width: 575px) {
    flex-direction: column;
    justify-content: center;

    h4 {
      margin-bottom: 10px;
    }
  }
}
</style>
